import BabeAccount from '@/views/babe/account'
import BabeActDetail from '@/views/babe/actdetail'
import BabeActivity from '@/views/babe/activity'
import BabeActList from '@/views/babe/actlist'
import BabeEdit from '@/views/babe/edit'
import BabeEventList from '@/views/babe/eventlist'
import BabeHotNft from '@/views/babe/hotnft'
import BabeMint from '@/views/babe/mint'
import BabeMintConfirm from '@/views/babe/mintconfirm'
import BabeMintSuccess from '@/views/babe/mintsuccess'
import BabeQuizDetail from '@/views/babe/quizdetail'
import BabeSpaceList from '@/views/babe/spacelist'
import BabeTransferList from '@/views/babe/transferlist'
import BabeVoteList from '@/views/babe/votelist'
import BabeWallet from '@/views/babe/wallet'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决vue路由重复导航错误
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes = [
  // babe
  {
    path: '/',
    name: 'BabeAccount',
    component: BabeAccount
  },
  {
    path: '/babe/account',
    name: 'BabeAccount',
    component: BabeAccount
  },
  {
    path: '/babe/edit',
    name: 'BabeEdit',
    component: BabeEdit
  },
  {
    path: '/babe/mint',
    name: 'BabeMint',
    component: BabeMint
  },
  {
    path: '/babe/mintconfirm',
    name: 'BabeMintConfirm',
    component: BabeMintConfirm
  },
  {
    path: '/babe/mintsuccess',
    name: 'BabeMintSuccess',
    component: BabeMintSuccess
  },
  {
    path: '/babe/wallet',
    name: 'BabeWallet',
    component: BabeWallet
  },
  {
    path: '/babe/activity',
    name: 'BabeActivity',
    meta: {
      keepAlive: true
    },
    component: BabeActivity
  },
  {
    path: '/babe/hotnft',
    name: 'BabeHotNft',
    component: BabeHotNft
  },
  {
    path: '/babe/actlist',
    name: 'BabeActList',
    component: BabeActList
  },
  {
    path: '/babe/actdetail',
    name: 'BabeActDetail',
    component: BabeActDetail
  },
  {
    path: '/babe/transferlist',
    name: 'BabeTransferList',
    component: BabeTransferList
  },
  {
    path: '/babe/quizdetail',
    name: 'BabeQuizDetail',
    component: BabeQuizDetail
  },
  {
    path: '/babe/votelist',
    name: 'BabeVoteList',
    component: BabeVoteList
  },
  {
    path: '/babe/spacelist',
    name: 'BabeSpaceList',
    meta: {
      keepAlive: true
    },
    component: BabeSpaceList
  },
  {
    path: '/babe/eventlist',
    name: 'BabeEventList',
    meta: {
      keepAlive: true
    },
    component: BabeEventList
  },
  {
    path: '*',
    name: 'NoPage',
    component: () => import('../views/404.vue')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   // document.body.scrollTop = 0
//   // document.documentElement.scrollTop = 0
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/babe.js